"use client";

import * as React from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const labelVariants = cva(
    "text-sm text-foreground font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 block",
    {
        variants: {
            variant: {
                default: "mb-1",
                heading:
                    "text-xl font-bold leading-tight mb-3 border-b border-border pb-1",
                pageHeading: "text-2xl font-bold leading-tight pb-1",
                statHeading: "text-lg font-bold leading-tight",
                statVal: "text-2xl font-bold leading-tight",
                headingtoggle: "font-semibold leading-tight text-base",
                toggle: "font-semibold leading-tight",
                subtoggle:
                    "text-xs text-muted-foreground leading-tight max-w-md",
                staffbar: "text-xs text-copy",
                staffSettings:
                    "font-semibold leading-tight text-base text-inherit flex items-center gap-1",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    }
);

interface LabelProps
    extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>,
        VariantProps<typeof labelVariants> {
    icon?: React.ReactNode;
}

const Label = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    LabelProps
>(({ variant, className, icon, ...props }, ref) => (
    <LabelPrimitive.Root
        ref={ref}
        className={cn(
            labelVariants({ variant }),
            "pointer-events-auto flex items-center gap-1",
            className
        )}
        {...props}
    >
        {icon}
        {props.children}
    </LabelPrimitive.Root>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
